import { useEffect, useState } from "react";
import { Copy, Loader2, Map as MapIcon } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TrackMap } from "@/components/tracking/TrackMap";
import { api, errMsg } from "@/lib/api";
import { agoText } from "@/lib/tracking";

const pt = (a) => (a?.lat != null ? [a.lat, a.lng] : null);
export const trackLink = (token) => `${window.location.origin}/boy/rastreio/${token}`;

export function useBoyTrack(token) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const load = () => api.get(`/public/boy-track/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [token]);
  return [d, err];
}

const statusText = (d) => (d.status === "entregue" ? "Entrega finalizada." : d.status !== "andamento" ? "Esta corrida não está em andamento."
  : d.position ? `${d.courier || "Entregador"} a caminho · ${agoText(d.position.at)}` : "Aguardando a localização do entregador…");

export function BoyLiveView({ d }) {
  return (
    <div className="space-y-2" data-testid="boy-live">
      <TrackMap store={pt(d.origin)} dest={pt(d.dest)} courier={pt(d.position)} courierLabel={d.courier || "Entregador"} />
      <p className="text-xs text-muted-foreground" data-testid="boy-live-status">{statusText(d)}</p>
    </div>
  );
}

function Live({ token }) {
  const [d, err] = useBoyTrack(token);
  if (err) return <p className="text-sm text-muted-foreground">{err}</p>;
  if (!d) return <p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p>;
  return <BoyLiveView d={d} />;
}

export function BoyTrackButton({ token, number, testId }) {
  const [open, setOpen] = useState(false);
  const copy = () => navigator.clipboard.writeText(trackLink(token)).then(() => toast.success("Link copiado")).catch(() => toast.error("Não foi possível copiar"));
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid={testId}><MapIcon className="mr-1.5 h-4 w-4" />Ver no mapa</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle>Corrida #{number} ao vivo</DialogTitle></DialogHeader>
          {open && <Live token={token} />}
          <Button variant="outline" onClick={copy} data-testid={`${testId}-copy`}><Copy className="mr-2 h-4 w-4" />Copiar link de acompanhamento</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
